/**
 * "Notes" section for the signal-only questions (`notes`), which the engine
 * surfaces but never scores. Rendered under the category table in the right
 * column, framed like the other scorecard sections.
 */
import { MatchSignal } from '../types';

interface Props {
  signals: MatchSignal[];
}

/** A signal value is the stored answer payload; text answers are `{ value }`. */
const signalText = (value: unknown): string => {
  if (value && typeof value === 'object' && 'value' in (value as Record<string, unknown>)) {
    const inner = (value as Record<string, unknown>).value;
    return typeof inner === 'string' ? inner : JSON.stringify(inner);
  }
  return typeof value === 'string' ? value : JSON.stringify(value);
};

export default function NotesSection({ signals }: Props) {
  if (signals.length === 0) return null;

  return (
    <div className="buyer-profile-match__notes-card">
      <div className="buyer-profile-match__notes-heading">Notes</div>
      <div className="buyer-profile-match__notes-body">
        {signals.map((s) => {
          const text = signalText(s.value).trim();
          return (
            <div key={s.questionKey} className="buyer-profile-match__note">
              {text ? (
                <div className="buyer-profile-match__note-text">{text}</div>
              ) : (
                <em className="buyer-profile-match__muted">No notes provided</em>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
